import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dialog", "photosContainer"]
    static values = { url: String, invoiceItemId: Number }

    openModal(event) {
        this.photosUrl = event.currentTarget.dataset.photosUrl
        this.loadPhotos()
        this.dialogTarget.showModal()
    }

    async loadPhotos() {
        this.photosContainerTarget.innerHTML = ""
        try {
            const response = await fetch(this.photosUrl)
            const photos = await response.json()
            this.displayPhotos(photos)
        } catch (error) {
            console.error("Ошибка при загрузке фотографий:", error)
            this.photosContainerTarget.innerHTML = "<p>Ошибка загрузки фотографий</p>"
        }
    }

    displayPhotos(photos) {
        if (photos.length === 0) {
            this.photosContainerTarget.innerHTML = `
                <div class="kit-empty-state">
                  <p class="text-caption">Нет фотографий</p>
                </div>
              `
            return
        }

        this.photosContainerTarget.innerHTML = `
            ${photos.map(photo => `
                <div class="kit-photo-gallery__item">
                    <img src="${photo.url}" loading="lazy">
                    <p class="text-caption">${photo.filename}</p>
                </div>
            `).join('')}
        `
    }

    closeModal() {
        this.dialogTarget.close()
        this.photosContainerTarget.innerHTML = ""
    }

    closeOnBackdrop(event) {
        if (event.target === this.dialogTarget) this.closeModal()
    }
}
